import { useEffect } from "react";

import MainLayout from "@/pages/layouts/MainLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/components/ui/tabs";
import BlogPosts from "./components/BlogPosts";
import Podcasts from "./components/Podcasts";
import { Glossary } from "./components/Glossary";
import { ResourcesActions } from "./components/ResourcesActions";
import { trackEvent, EventType } from "@/shared/utils/core";

export const ResourcesPage = () => {
  useEffect(() => {
    trackEvent(EventType.RESOURCES_ACCESSED, {
      entry_point: "navigation",
    });
  }, []);

  return (
    <MainLayout header="Community & resources" actions={<ResourcesActions />}>
      <Tabs defaultValue="guides" className="flex flex-col w-full">
        <TabsList hideMobileDropdown={true}>
          <TabsTrigger value="guides">Helpful Guides</TabsTrigger>
          <TabsTrigger value="glossary">Estate Glossary</TabsTrigger>
        </TabsList>

        <TabsContent value="guides" className="flex flex-col w-full mt-0">
          <div className="flex flex-col gap-10 mt-6">
            {/*<SupportGroups /> */}
            <Podcasts />
            <BlogPosts />
          </div>
        </TabsContent>

        <TabsContent value="glossary" className="mt-0">
          <div className="mt-6">
            <Glossary />
          </div>
        </TabsContent>
      </Tabs>
    </MainLayout>
  );
};
